import React, { useMemo } from "react";

import { hmsUiClassParserGenerator } from "../../common/classes";

import {
  Button,
  Settings,
  VerticalDivider,
  useHMSTheme,
  HangUpIcon,
  MicOffIcon,
  MicOnIcon,
  CamOffIcon,
  CamOnIcon,
  ShareScreenIcon,
  ChatUnreadIcon,
} from "@100mslive/hms-video-react";

// Note: Column Gap is not supported in safari
const defaultClasses = {
  root: "flex bg-white dark:bg-black h-full items-center p-3 mr-2 ml-2 justify-center md:justify-between relative",
  leftRoot: "flex justify-center items-center z-10 space-x-2 md:space-x-3",
  centerRoot:
    "flex md:flex-1 mr-4 ml-2 md:ml-0 md:mr-0 justify-center items-center md:absolute md:left-0 md:right-0",
  rightRoot: "z-10 items-center flex",
};

export const ControlBar = ({
  isAudioMuted = false,
  isVideoMuted = false,
  isChatOpen = false,
  buttonDisplay = "rectangle",
  audioButtonOnClick,
  videoButtonOnClick,
  leaveButtonOnClick,
  chatButtonOnClick,
  screenshareButtonOnClick,
  leftComponents = [
    <Settings key={0} />,
    <VerticalDivider key={1} />,
    <Button
      iconOnly
      variant="no-fill"
      iconSize="md"
      classes={{ root: "w-14" }}
      shape={buttonDisplay}
      onClick={screenshareButtonOnClick}
      key={2}
    >
      <ShareScreenIcon />
    </Button>,
    <VerticalDivider key={3} />,
    <Button
      iconOnly
      variant="no-fill"
      iconSize="md"
      shape={buttonDisplay}
      onClick={chatButtonOnClick}
      active={isChatOpen}
      key={4}
    >
      <ChatUnreadIcon />
    </Button>,
  ],
  centerComponents = [
    <Button
      iconOnly
      variant="no-fill"
      iconSize="md"
      classes={{ root: "mr-2" }}
      shape={buttonDisplay}
      active={isAudioMuted}
      onClick={audioButtonOnClick}
      key={0}
    >
      {isAudioMuted ? <MicOffIcon /> : <MicOnIcon />}
    </Button>,
    <Button
      iconOnly
      variant="no-fill"
      iconSize="md"
      shape={buttonDisplay}
      active={isVideoMuted}
      onClick={videoButtonOnClick}
      key={1}
    >
      {isVideoMuted ? <CamOffIcon /> : <CamOnIcon />}
    </Button>,
  ],
  rightComponents = [
    <Button
      size="md"
      shape={buttonDisplay}
      variant="danger"
      onClick={leaveButtonOnClick}
      icon={<HangUpIcon />}
      key={0}
    >
      Leave room
    </Button>,
  ],
  classes,
}) => {
  const { tw } = useHMSTheme();
  const styler = useMemo(
    () =>
      hmsUiClassParserGenerator({
        tw,
        classes,
        defaultClasses,
        tag: "hmsui-controlbar",
      }),
    []
  );

  const leftItems = [];
  const centerItems = [];
  const rightItems = [];

  centerComponents.forEach(comp => {
    centerItems.push(comp);
  });
  rightComponents.forEach(comp => {
    rightItems.push(comp);
  });

  //   leftComponents.forEach(comp => {
  //     leftItems.push(comp);
  //   });

  return (
    <div className={styler("root")}>
      <div className={styler("leftRoot")}>{leftItems}</div>
      <div className={styler("centerRoot")}>{centerItems}</div>
      <div className={styler("rightRoot")}>{rightItems}</div>
    </div>
  );
};
